import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import Button from '../../../../../../components/Button'
import FacebookExistingPostPreview from '../../../../../../features/components/FacebookPreviews/FacebookExistingPostPreview'

import { FORMAT_EXISTING_POST, FORMAT_OPTION, PIXEL_CHOICE } from '../../../fields'

import useStyles from '../../../../../../styles/common/stepForms'
import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const EventSourceStep = ({ formik, handleStepChange, formattedPixels }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values } = formik

  const formatOption = values[FORMAT_OPTION]

  const renderPreview = useCallback(() => {
    if (formatOption === FORMAT_EXISTING_POST) {
      return <FacebookExistingPostPreview values={values} />
    }

    return null
  }, [formatOption, values])

  return (
    <>
      <div className={classes.stepTitle}>{t('Select the pixel that is installed on your website')}</div>
      <div className={classes.stepBody}>
        <div className={drawerFormClasses.section}>
          {renderPreview()}
          <h3 className={drawerFormClasses.sectionTitle}>{t('Event Source')}</h3>
          <Field placeholder={t('Event source')} formik={formik} name={PIXEL_CHOICE} options={formattedPixels} />
        </div>
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={() => handleStepChange()}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default EventSourceStep
